import { api } from '@setplex/tria-api'
import { combine, createEvent, sample } from 'effector'
import { not } from 'patronum'
import { liveEventsPurchasedEntityModel } from '~/entities/live-events/purchased'

export const loadGridPurchasedLiveEvents = createEvent()

sample({
  clock: loadGridPurchasedLiveEvents,
  filter: not(api.liveEvents.getPurchasedLiveEventsGridFx.pending),
  target: api.liveEvents.getPurchasedLiveEventsGridFx,
})

export const $isGridPurchasedLiveEventsLoading = combine(
  {
    purchasedLiveEventsLoading:
      api.liveEvents.getPurchasedLiveEventsGridFx.pending,
    purchasedLiveEvents:
      liveEventsPurchasedEntityModel.$purchasedLiveEventsGrid,
  },
  ({ purchasedLiveEventsLoading, purchasedLiveEvents }) =>
    !purchasedLiveEvents && purchasedLiveEventsLoading
)

export const loadMoreGridPurchasedLiveEvents = createEvent()

sample({
  clock: loadMoreGridPurchasedLiveEvents,
  filter: not(api.liveEvents.getPurchasedLiveEventsGridFx.pending),
  fn: () => null,
  target: liveEventsPurchasedEntityModel.loadMorePurchasedLiveEventsGrid,
})
